export const notEmptyRule = {
    pattern: {
        value: /.*[^ ].*/gm,
        message: 'Cannot be empty'
    }
};
